<template>
  <div class="modal fade" id="ViewEMIRecord">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-aqua">
            <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            <button @click="printViewEMIRecord()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
        </div>
        <div class="modal-body" id="printViewEMIRecord">
            <div class="row printing">
            
              <div class="col-md-12">
                <!-- Profile Image -->
                <div class="card card-primary card-outline">
                  <div class="card-body box-profile">
                    <table class="table table-condensed" style="border-width:2px;">
                      <thead tyle="border-width:2px;">
                        <td tyle="border-width:2px;"><img :src="logo" height="100"></td>
                        <td class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                          <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                          </small></h4></td>
                      </thead>
                      <tbody>
                        <td>
                          <strong> Branch : <i v-if="memberloanplan.branch">{{memberloanplan.branch.name}} </i><br>
                          Application No : {{memberloanplan.applicationNo}}<br>
                          Total Amt : {{memberloanplan.totalAmt}} <br>
                          Received Amt : {{memberloanplan.receivedAmt}}
                          </strong>
                        </td>
                        <td class="text-right"><strong v-if="memberloanplan.member">Cust Name : {{memberloanplan.member.name}} <br>
                          Cust Code : {{memberloanplan.member.code}} <br>
                          Cust Mobile : {{memberloanplan.member.mobile}}</strong>
                        </td>
                      </tbody>
                    </table>
                    <h2 class="text-center">LOAN EMI RECORDS</h2>
                    <table class="table table-condensed" width="100%">
                      <thead>
                        <td>Sr.</td>
                        <td>EMI Date</td>
                        <td>Principal</td>
                        <td>Interest</td>
                        <td>Total</td>
                        <!-- <td>Adjustment</td> -->
                        <td>Balance</td>
                        <td>Received</td>
                        <td>Arrear</td>
                        <td>Advance</td>
                        <td>Status</td>
                      </thead>
                      <tbody>
                        <tr v-for="(ro, index) in rows" :key="index">
                          <td>{{index + 1}}</td>
                          <td><i v-if="ro.emiDate">{{ro.emiDate | myDate}}</i></td>
                          <td><i v-if="ro.principal">{{ro.principal}}</i></td>
                          <td><i v-if="ro.intrest">{{ro.intrest}}</i></td>
                          <td><i v-if="ro.total">{{ro.total}}</i></td>
                          <!-- <td><i v-if="ro.adjustment">{{ro.adjustment}}</i></td> -->
                          <td><i v-if="ro.balance">{{ro.balance}}</i></td>
                          <td><i v-if="ro.received">{{ro.received}}</i></td>
                          <td><i v-if="ro.arrear">{{ro.arrear}}</i></td>
                          <td><i v-if="ro.advance">{{ro.advance}}</i></td>
                          <td><i v-if="ro.status">{{emistatus(ro.status)}}</i></td>
                        </tr>
                      </tbody>
                    </table>
                    <p style="page-break-before: always;"></p>
                    <table class="table table-condensed">
                      <thead tyle="border-width:1px;">
                        <td tyle="border-width:1px;"><img :src="logo" height="100"></td>
                        <td class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                          <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                          </small></h4></td>
                      </thead>
                      <tbody>
                        <td>
                          <strong> Branch : <i v-if="memberloanplan.branch">{{memberloanplan.branch.name}} </i><br>
                          Application No : {{memberloanplan.applicationNo}}<br>
                          Total Amt : {{memberloanplan.totalAmt}} <br>
                          Received Amt : {{memberloanplan.receivedAmt}}
                          </strong>
                        </td>
                        <td class="text-right"><strong v-if="memberloanplan.member">Cust Name : {{memberloanplan.member.name}} <br>
                          Cust Code : {{memberloanplan.member.code}} <br>
                          Cust Mobile : {{memberloanplan.member.mobile}}</strong>
                        </td>
                      </tbody>
                    </table>
                    <h2 class="text-center">CUSTOMER PAYMENT RECORDS</h2>
                    <table class="table table-sm table-bordered table-hover" style="width: 100%">
                      <thead style="background-color: #d6dddd;">
                        <tr>
                          <th>Sr.</th>
                          <th>Type</th>
                          <th>Pay Date</th>
                          <th>Amount</th>
                          <th>Received By</th>
                          <th>Mode</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(payRecord, index) in rowsMemberCollections" :key="index">
                          <td>{{ (index + 1) }}</td>
                          <td><i v-if="payRecord.type === 'panulty'">penalty</i><i v-else>{{ payRecord.type }}</i></td>
                          <td>{{ payRecord.paymentDate | myDate}}</td>
                          <td>{{ payRecord.amt }}</td>
                          <td><span v-if="payRecord.received_by">{{ payRecord.received_by.name }}</span></td>
                          <td><span v-if="payRecord.branch_ledger">{{ payRecord.branch_ledger.ledger.name }}</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- /.card-body -->
                </div>
                <!-- /.card -->
              </div>
            <!-- /.col -->
            
            </div>
        </div>
        <div class="modal-footer text-center">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Printd } from 'printd'
export default {
  name: 'PrintEMIRecords',
  props: ['rows', 'getCompanyRecord', 'logo', 'memberloanplan', 'rowsMemberCollections'],
  data () {
    return {
      cssText: `.printing {
        font-family: sans-serif;
        text-align: center;
        padding-bottom: 2rem;

        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
      }
      @page {
        size: A4;
        margin: 0;
      }
      
      p {
        font-weight: bold;
      }
      table.center {
        margin-left: auto; 
        margin-right: auto;
      }
      table th, table td { border:1px solid #000; padding:0.5em; border-collapse: collapse; }`
    }
  },
  methods: {
    emistatus (status) {
      if (status === 'sattle') {
        return 'settle'
      } else {
        return status
      }
    },
    printViewEMIRecord () {
      const d = new Printd()
      // Get HTML to print from element
      // const prtHtml = document.getElementById('printViewEMIRecord').innerHTML

      // Get all stylesheets HTML
      // let stylesHtml = ''
      // for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
      //   stylesHtml += node.outerHTML
      // }
      d.print(document.getElementById('printViewEMIRecord'), [this.cssText])
      // Open the print window
      // const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      // WinPrint.document.write(`<!DOCTYPE html>
      //   <html>
      //     <head>
      //       <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/3.4/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
      //         ${stylesHtml}
      //         <style type="text/css">
      //           table th, table td { border:2px solid #000; padding:0.5em; }
      //         </style>
      //     </head>
      //     <body>
      //         ${prtHtml}
      //     </body>
      //   </html>`)

      // WinPrint.document.close()
      // WinPrint.focus()
      // WinPrint.print()
      // WinPrint.close()
    }
  }
}
</script>




// WEBPACK FOOTER //
// PrintEMIRecords.vue?1557cc9c